import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '1232252005518849';
// Helper to track events from anywhere
export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
}
export function MetaPixel() {
  useEffect(() => {
    // 1. Add facebook-domain-verification meta tags
    const metaTag = document.createElement('meta');
    metaTag.name = 'facebook-domain-verification';
    metaTag.content = 'xh9ygvde233gpeteatmy8qndjatqwp';
    document.head.appendChild(metaTag);
    const metaTag2 = document.createElement('meta');
    metaTag2.name = 'facebook-domain-verification';
    metaTag2.content = '9nj3o3la8d5ji5wvxqm9035wpn9gu7';
    document.head.appendChild(metaTag2);
    // 2. Initialize Meta Pixel
    if (window.fbq) return; // Already initialized
    const f: any = window;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Load pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Init pixel and fire PageView
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      // Cleanup meta tags on unmount
      if (metaTag.parentNode) metaTag.parentNode.removeChild(metaTag);
      if (metaTag2.parentNode) metaTag2.parentNode.removeChild(metaTag2);
    };
  }, []);
  return null;
}